import { sendContactFormService } from "../services"

export default (name, email, phone, companyName, productDetail) => {
	return new Promise((resolve, reject) => {
		sendContactFormService.sendForm(name, email, phone, companyName, productDetail)
			.then(response => resolve(response.data))
			.catch(() => reject({ error: true }))
	})
}
